var map = {
	"./button/style/index.ts": "./src/button/style/index.ts",
	"./form/style/index.ts": "./src/form/style/index.ts",
	"./icon/style/index.ts": "./src/icon/style/index.ts",
	"./image/style/index.ts": "./src/image/style/index.ts",
	"./input/style/index.ts": "./src/input/style/index.ts",
	"./label/style/index.ts": "./src/label/style/index.ts",
	"./mask/style/index.ts": "./src/mask/style/index.ts",
	"./modal/style/index.ts": "./src/modal/style/index.ts",
	"./navigator/style/index.ts": "./src/navigator/style/index.ts",
	"./picker-view-column/style/index.ts": "./src/picker-view-column/style/index.ts",
	"./picker-view/style/index.ts": "./src/picker-view/style/index.ts",
	"./preview/style/index.ts": "./src/preview/style/index.ts",
	"./progress/style/index.ts": "./src/progress/style/index.ts",
	"./rich-text/style/index.ts": "./src/rich-text/style/index.ts",
	"./scroll-view/style/index.ts": "./src/scroll-view/style/index.ts",
	"./swiper-item/style/index.ts": "./src/swiper-item/style/index.ts",
	"./swiper/style/index.ts": "./src/swiper/style/index.ts",
	"./switch/style/index.ts": "./src/switch/style/index.ts",
	"./text/style/index.ts": "./src/text/style/index.ts",
	"./textarea/style/index.ts": "./src/textarea/style/index.ts",
	"./toast/style/index.ts": "./src/toast/style/index.ts",
	"./video/style/index.ts": "./src/video/style/index.ts",
	"./view/style/index.ts": "./src/view/style/index.ts",
	"./web-view/style/index.ts": "./src/web-view/style/index.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive ^\\.\\/[^_][\\w-]+\\/style\\/index\\.tsx?$";